import { render, staticRenderFns } from "./dictionnaire.vue?vue&type=template&id=589256d7&scoped=true"
import script from "./dictionnaire.vue?vue&type=script&lang=js"
export * from "./dictionnaire.vue?vue&type=script&lang=js"
import style0 from "./dictionnaire.vue?vue&type=style&index=0&id=589256d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589256d7",
  null
  
)

export default component.exports